<template>
  <v-container fluid>
    <v-toolbar dense flat>
      <v-btn-toggle v-model="computedSettings.tab" dense mandatory color="primary">
        <v-btn value="systemLevel" small> System Level </v-btn>
        <v-btn value="nodal" small> Nodal </v-btn>
      </v-btn-toggle>
      <v-spacer />
      <v-btn-toggle v-model="computedSettings.viewMode" mandatory dense color="primary">
        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn v-on="on" text value="dashboard" small>
              <v-icon>mdi-view-dashboard</v-icon>
            </v-btn>
          </template>
          <span>Dashboard</span>
        </v-tooltip>
        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn v-on="on" text value="tabular" small>
              <v-icon>mdi-view-list</v-icon>
            </v-btn>
          </template>
          <span>Tabular</span>
        </v-tooltip>
      </v-btn-toggle>
    </v-toolbar>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: "OutputNodalPCToolbar",
  components: {},
  mixins: [],
  props: {
    settings: { type: Object, required: true },
  },
  data() {
    return {};
  },
  computed: {
    computedSettings: {
      get() {
        return this.settings;
      },
      set(val) {
        this.$emit("update:settings", val);
      },
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style></style>
